import { AuthService, Login } from '@skinsoft/auth';
import { first, map } from 'rxjs/operators';
import Router from 'vue-router';
import { router as unifiedRouter } from '../../../reporter-launcher/src/router' // TODO better'

import { MovementDataStore, TaskDataStore } from '@skinsoft/entity';
import {
    MovementFeaturedList,
    MovementHistory,
    TaskFeaturedList,
    TaskHistory,
} from '@skinsoft/entity-ui';

import { Dashboard } from './dashboard';
import { ActionMenuMovement } from './entity/component/action-menu/movement';
import { ActionMenuTask } from './entity/component/action-menu/task';
import { EntityList } from './entity/page/entity-list';
import { MovementPage } from './entity/page/movement';
import { TaskPage } from './entity/page/task';


declare var UNIFY_ROUTER: boolean;

export enum Routes {
    TRACKING_HOME = 'trackingHome',
    LOGIN = 'login',
    MOVEMENT = 'movement',
    MOVEMENTS = 'movements',
    TASK = 'task',
    TASKS = 'tasks',
}

const routes = [
    {
        component: Dashboard,
        name: Routes.TRACKING_HOME,
        path: '/trackingHome',
    },
    {
        component: EntityList,
        name: Routes.TASKS,
        path: '/tasks',
        props: {
            entityDataStore: TaskDataStore.getInstance(),
            entityFeaturedList: TaskFeaturedList,
            entityHistory: TaskHistory,
            targetRouteName: Routes.TASK,
        },
    },
    {
        components: {
            actionMenu: ActionMenuMovement,
            default: EntityList,
        },
        name: Routes.MOVEMENTS,
        path: '/movements',
        props: {
            actionMenu: {
                entityDataStore: MovementDataStore.getInstance(),
            },
            default: {
                entityDataStore: MovementDataStore.getInstance(),
                entityFeaturedList: MovementFeaturedList,
                entityHistory: MovementHistory,
                targetRouteName: Routes.MOVEMENT,
            },
        },
    },
    {
        components: {
            actionMenu: ActionMenuMovement,
            default: MovementPage,
        },
        name: Routes.MOVEMENT,
        path: '/movements/:id',
        props: {
            actionMenu: {
                entityDataStore: MovementDataStore.getInstance(),
            },
        },
    },
    {
        components: {
            actionMenu: ActionMenuTask,
            default: TaskPage,
        },
        name: Routes.TASK,
        path: '/tasks/:id',
        props: {
            actionMenu: {
                entityDataStore: TaskDataStore.getInstance(),
            },
        },
    },
    { path: '*', redirect: '/trackingHome' },
]
// tslint:disable-next-line:variable-name
let _router: Router;

// If app is embedded in launcher, use launcher router
if (UNIFY_ROUTER) {
    _router = unifiedRouter
}
// If app is standalone, use its own router
else {
    _router = new Router({
        mode: 'history',
    });
    routes.push()
    _router.addRoutes([{
        component: Login,
        name: Routes.LOGIN,
        props: {
            homeRoute: Routes.TRACKING_HOME
        },
        path: '/login',
    }])
}
_router.addRoutes(routes)

export const router = _router;

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!authenticated && to.name !== Routes.LOGIN) {
                    return { name: Routes.LOGIN };
                }

                if (authenticated && to.name === Routes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
